/**
 * @generated SignedSource<<96611e5eff010b02d97af775594419a7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SwiperItem_video$data = {
  readonly videoThumb: string | null;
  readonly height: number | null;
  readonly width: number | null;
  readonly fileByVideoSize: {
    readonly link: string | null;
  } | null;
  readonly " $fragmentType": "SwiperItem_video";
};
export type SwiperItem_video$key = {
  readonly " $data"?: SwiperItem_video$data;
  readonly " $fragmentSpreads": FragmentRefs<"SwiperItem_video">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SwiperItem_video",
  "selections": [
    {
      "alias": "videoThumb",
      "args": [
        {
          "kind": "Literal",
          "name": "pad",
          "value": false
        },
        {
          "kind": "Literal",
          "name": "size",
          "value": "w295h166"
        }
      ],
      "kind": "ScalarField",
      "name": "thumbnail",
      "storageKey": "thumbnail(pad:false,size:\"w295h166\")"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "height",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "width",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "VideoVimeoFile",
      "kind": "LinkedField",
      "name": "fileByVideoSize",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "link",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "VideoVimeo",
  "abstractKey": null
};

(node as any).hash = "3f24d41d52206d5ffc1a91c7ad509637";

export default node;
